module.exports = __webpack_public_path__ + "img/logo.701e85e7.png";